export const MOCK_OVERVIEW = {
  totalSkus: 48250,
  optimizedSkus: 12480,
  pendingSkus: 35770,
  linkedListings: 92104,
  verifiedDataTypes: 6,
};

export const MOCK_STORE_OPTIONS = [
  { _id: 'store-1', name: 'Rev & Bolt — eBay US' },
  { _id: 'store-2', name: 'Rev & Bolt — eBay CA' },
];

export const MOCK_SUPPLIER_OPTIONS = [
  { _id: 'sup-1', name: 'Car Parts Wholesale' },
  { _id: 'sup-2', name: 'Premier Auto Supply' },
  { _id: 'sup-3', name: 'Midwest Parts Co.' },
];

export const PROCESS_STEPS = [
  { id: 'scope', label: 'Resolve SKU scope', description: 'Apply store, supplier, or manual SKU filters' },
  { id: 'mapping', label: 'Load SKU → Partslink mapping', description: 'Validate uploaded mapping file' },
  { id: 'fetch', label: 'Fetch verified eBay data', description: 'Pull item specifics and fitment from verified seller listing' },
  { id: 'specs', label: 'Update item specifics & fitment', description: 'Apply item specs rules and write fitment to SKU catalog only' },
  { id: 'listings', label: 'Sync linked listings', description: 'Push saved catalog to linked eBay listings when direct update is on' },
  { id: 'persist', label: 'Persist optimizer records', description: 'Save run history and verified field flags' },
];

export const MOCK_SKU_LOOKUP = {
  'CAR-HO123': {
    canonicalSku: 'CAR-HO123',
    partslink: 'HO123456',
    title: 'Front Brake Pad Set — Honda Accord',
    supplierCount: 2,
    listingCount: 4,
    dataProfile: { aggregate: 'Complete' },
    optimizer: {
      status: 'optimized',
      lastRunAt: '2026-05-18T14:22:00.000Z',
      lastRunStatus: 'completed',
      verifiedFields: ['itemSpecifics', 'fitment'],
      updatedAt: '2026-05-18T14:22:05.000Z',
      runCount: 3,
      notes: 'Item specifics rebuilt from carpartswholesale reference.',
    },
    suppliers: [
      { name: 'Car Parts Wholesale', sku: 'CPW-HO123', qty: 42 },
      { name: 'Premier Auto Supply', sku: 'PAS-8891', qty: 18 },
    ],
    listings: [
      { store: 'Rev & Bolt — eBay US', marketplaceId: '123456789012', status: 'active' },
      { store: 'Rev & Bolt — eBay US', marketplaceId: '123456789013', status: 'active' },
      { store: 'Rev & Bolt — eBay CA', marketplaceId: '998877665544', status: 'active' },
      { store: 'Rev & Bolt — eBay CA', marketplaceId: '998877665545', status: 'ended' },
    ],
  },
};
